export const userRoutes = {
  getProfile: '/user/profile',
  getPortfolio: '/user/portfolio',
  getTradingAccounts: '/user/trading-accounts',
  getBalance: '/user/balance',
  getSettings: '/user/settings',
  postTradingAccount: (platformLogin: string) =>
    `/user/change-trading-account?platformLogin=${platformLogin}`,
} as const;
